import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth token lives ONLY in the httpOnly cookie set by the backend (access_token).
// We never read it in JS to avoid XSS risk. `withCredentials: true` sends the cookie.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Uploaded product images are served by the API as a relative path
// (/api/products/{id}/image). Resolve them against the backend origin.
export function mediaUrl(src) {
  if (!src) return "";
  return src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
